import React, { useCallback } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { SVGType } from '@interfaces';

import { useAssistant } from '@core/assistant/providers/Provider';
import { SCREENS } from '@core/assistant/interfaces';

import { useStyles } from './styles';

interface IQuestionBox {
  title: string;
  icon: SVGType;
}

const QuestionBox = ({ title, icon: Icon }: IQuestionBox) => {
  const classes = useStyles();

  const { handleSendRequest, navigate } = useAssistant();

  const handleSendMessage = useCallback(() => {
    handleSendRequest(title);
    navigate(SCREENS.CHAT);
  }, [title]);

  return (
    <Button onClick={handleSendMessage} sx={classes.box}>
      <Box sx={classes.icon}>
        <Icon />
      </Box>

      <Typography sx={classes.title}>{title}</Typography>
    </Button>
  );
};

export default QuestionBox;
